import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import TextField from '../../component/TextField';
import CheckBox from '../../component/CheckBox';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import SimpleReactValidator from 'simple-react-validator';
import ConditionBlock from '../../component/pageTakeover/ConditionBlock';
import Loader from '../../component/loader';
import PopUpCustomAll from '../../component/fpg/create/popUpCustomAll';
import ErrorPopUp from '../../component/errorPopUp';
import moment from 'moment';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../redux/bindActionCretor';
import service from '../../services';
import DropdownMaster from '../../component/DropdownMaster';
import FpgPlusIcon from '../../icons/fpgplusicon';
import FpgMinusIcon from '../../icons/fpgminusicon';
import { PAGE_TAKEOVER_DISPLAY_PAGE_OPTIONS as DISPLAY_PAGE_OPTIONS, PAGE_TAKEOVER_PAGE_LABEL_MAP as PAGE_LABEL_MAP, PT_CONDITION_TYPE } from '../../cosntants';

const mapStateToProps = state => ({
    pageTakeoverEditId: state.pageTakeoverEditId,
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

let sub;
class PageTakeoverCreate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loaderFlag: false,
            discardPopup: false,
            isEditMode: false,
            pageTakeoverId: this.props.pageTakeoverEditId,

            // Basic Info
            name: '',
            status: 1,

            // Trigger Conditions
            triggerConditions: [
                { condition: PT_CONDITION_TYPE.PAGE_LOADED, targetId: '' }
            ],

            // Distinct Displays
            distinctDisplayCount: 1,
            distinctDisplayUnlimited: false,

            // Scheduling
            startEnabled: false,
            startDatetime: null,
            endEnabled: false,
            endDatetime: null,

            // Display Pages
            displayPages: [],
            otherPages: [''],

            // Takeover Content
            takeoverContent: '',

            errorPopup: false,
            errorMsg: '',
            originalData: null,
            showValidation: false,
        }

        this.apiserve = new service();
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                pageTakeoverName: {
                    message: 'The Name field is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true
                },
                displayPagesRequired: {
                    message: 'Please select at least one display page.',
                    rule: (val) => {
                        return val && val.length > 0
                    },
                    required: true
                },
                takeoverContentRequired: {
                    message: 'The Takeover Content field is required.',
                    rule: (val) => {
                        return val && val.trim().length > 0
                    },
                    required: true
                },
                displayCountRequired: {
                    message: 'The Display Count field is required.',
                    rule: (val) => {
                        return val && parseInt(val) >= 1
                    },
                    required: true
                },
                startDateRequired: {
                    message: 'The Start Date & Time field is required.',
                    rule: (val) => {
                        return val !== null && val !== '' && val !== undefined
                    },
                    required: true
                },
                endDateRequired: {
                    message: 'The End Date & Time field is required.',
                    rule: (val) => {
                        return val !== null && val !== '' && val !== undefined
                    },
                    required: true
                },
                endAfterStart: {
                    message: 'End date must be after start date.',
                    rule: (val, params) => {
                        if (!params[0]) return true;
                        return new Date(val).getTime() > parseInt(params[0], 10)
                    },
                    required: false
                },
                conditionValueRequired: {
                    message: 'The Value field is required.',
                    rule: (val) => {
                        return val && val.trim().length > 0
                    },
                    required: true
                },
                otherPageRequired: {
                    message: 'The :attribute field is required.',
                    rule: (val) => {
                        return val && val.trim().length > 0
                    },
                    required: true
                },
            }
        })
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    componentDidMount() {
        // Restore draft state if returning from preview
        const draftJson = sessionStorage.getItem('pageTakeoverFormDraft');
        if (draftJson) {
            try {
                const draft = JSON.parse(draftJson);
                sessionStorage.removeItem('pageTakeoverFormDraft');
                this.setState({
                    isEditMode: draft.isEditMode || false,
                    pageTakeoverId: draft.pageTakeoverId || null,
                    originalData: draft.originalData || null,
                    name: draft.name || '',
                    status: draft.status || 1,
                    triggerConditions: draft.triggerConditions || [{ condition: 'pageLoaded', targetId: '' }],
                    distinctDisplayCount: draft.distinctDisplayCount || 1,
                    distinctDisplayUnlimited: draft.distinctDisplayUnlimited || false,
                    startEnabled: draft.startEnabled || false,
                    startDatetime: draft.startDatetime ? new Date(draft.startDatetime) : null,
                    endEnabled: draft.endEnabled || false,
                    endDatetime: draft.endDatetime ? new Date(draft.endDatetime) : null,
                    displayPages: draft.displayPages || [],
                    otherPages: draft.otherPages || [''],
                    takeoverContent: draft.takeoverContent || '',
                });
            } catch (e) {
                sessionStorage.removeItem('pageTakeoverFormDraft');
            }
        } else {
            // Check if edit mode
            const editId = this.props.pageTakeoverEditId || (this.props.match && this.props.match.params && this.props.match.params.pageTakeoverEditId);
            if (editId) {
                this.setState({ isEditMode: true, pageTakeoverId: editId, loaderFlag: true })
                this.apiserve.sendevent("pageTakeOver|getPageTakeOverById", { id: editId });
            }
        }

        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "pageTakeOver|getPageTakeOverById":
                    if (!response.error && response.data) {
                        const data = response.data.data || response.data;
                        // Map triggerActions from API to triggerConditions state
                        let conditions = [{ condition: PT_CONDITION_TYPE.PAGE_LOADED, targetId: '' }];
                        if (data.triggerActions && data.triggerActions.length) {
                            conditions = data.triggerActions.map(a => ({
                                condition: a.condition,
                                targetId: a.condition === PT_CONDITION_TYPE.EVENT_FIRED ? (a.eventName || '') : (a.targetId || '')
                            }));
                        }
                        // Map status string to number
                        const statusNum = data.status === 'active' ? 1 : (data.status === 'inactive' ? 2 : (data.status || 1));
                        const editState = {
                            name: data.name || '',
                            status: statusNum,
                            triggerConditions: conditions,
                            distinctDisplayCount: data.distinctDisplays ? data.distinctDisplays.max || 1 : 1,
                            distinctDisplayUnlimited: data.distinctDisplays ? data.distinctDisplays.unlimited || false : false,
                            startEnabled: data.startDatetime ? data.startDatetime.enabled || false : false,
                            startDatetime: data.startDatetime && data.startDatetime.datetime ? new Date(moment(data.startDatetime.datetime)) : null,
                            endEnabled: data.endDatetime ? data.endDatetime.enabled || false : false,
                            endDatetime: data.endDatetime && data.endDatetime.datetime ? new Date(moment(data.endDatetime.datetime)) : null,
                            displayPages: data.displayPages
                                ? (() => {
                                    const knownOpts = DISPLAY_PAGE_OPTIONS.filter(o => o.value !== 'other').map(o => o.value);
                                    const mapped = data.displayPages
                                        .filter(p => knownOpts.includes(p))
                                        .map(p => ({ value: p, label: PAGE_LABEL_MAP[p] }));
                                    const hasCustom = data.displayPages.some(p => !knownOpts.includes(p));
                                    if (hasCustom) mapped.push({ value: 'other', label: 'Other' });
                                    return mapped;
                                })()
                                : [],
                            takeoverContent: data.takeoverContent || '',
                        };
                        // Extract custom "other" page values if present
                        const knownValues = DISPLAY_PAGE_OPTIONS.filter(o => o.value !== 'other').map(o => o.value);
                        const otherPagesList = data.displayPages ? data.displayPages.filter(p => !knownValues.includes(p)) : [];
                        editState.otherPages = otherPagesList.length ? otherPagesList : [''];
                        const originalSnapshot = {
                            ...editState,
                            startDatetime: editState.startDatetime ? editState.startDatetime.getTime() : null,
                            endDatetime: editState.endDatetime ? editState.endDatetime.getTime() : null,
                            triggerConditions: JSON.parse(JSON.stringify(editState.triggerConditions)),
                            displayPages: JSON.parse(JSON.stringify(editState.displayPages)),
                        };
                        this.setState({
                            loaderFlag: false,
                            ...editState,
                            originalData: originalSnapshot,
                        })
                    } else {
                        this.setState({ loaderFlag: false })
                    }
                    break;
                case "pageTakeOver|create":
                    if (!response.error && !(response.data && response.data.success === false)) {
                        this.setState({ loaderFlag: false })
                        this.apiserve.success("Page takeover created successfully");
                        this.props.history.push('/page-takeover-list');
                    } else {
                        this.setState({
                            loaderFlag: false,
                            errorPopup: true,
                            errorMsg: (response.data && response.data.error) ? response.data.error : response.data
                        })
                    }
                    break;
                case "pageTakeOver|update":
                    if (!response.error && !(response.data && response.data.success === false)) {
                        // Re-fetch updated data so form reflects saved state and submit btn disables
                        this.apiserve.sendevent("pageTakeOver|getPageTakeOverById", { id: this.state.pageTakeoverId });
                        this.apiserve.success("Page takeover updated successfully");
                    } else {
                        this.setState({
                            loaderFlag: false,
                            errorPopup: true,
                            errorMsg: (response.data && response.data.error) ? response.data.error : response.data
                        })
                    }
                    break;
                default:
                    break;
            }
        })
    }

    isFormDirty = () => {
        if (!this.state.isEditMode || !this.state.originalData) return true;
        const orig = this.state.originalData;
        if (this.state.name !== orig.name) return true;
        if (this.state.status !== orig.status) return true;
        if (this.state.takeoverContent !== orig.takeoverContent) return true;
        if (this.state.distinctDisplayCount !== orig.distinctDisplayCount) return true;
        if (this.state.distinctDisplayUnlimited !== orig.distinctDisplayUnlimited) return true;
        if (this.state.startEnabled !== orig.startEnabled) return true;
        if (this.state.endEnabled !== orig.endEnabled) return true;
        const curStart = this.state.startDatetime ? this.state.startDatetime.getTime() : null;
        const curEnd = this.state.endDatetime ? this.state.endDatetime.getTime() : null;
        if (curStart !== orig.startDatetime) return true;
        if (curEnd !== orig.endDatetime) return true;
        if (JSON.stringify(this.state.triggerConditions) !== JSON.stringify(orig.triggerConditions)) return true;
        if (JSON.stringify(this.state.displayPages) !== JSON.stringify(orig.displayPages)) return true;
        if (JSON.stringify(this.state.otherPages) !== JSON.stringify(orig.otherPages)) return true;
        return false;
    }

    // Input handlers
    onChangeHandler = (e) => {
        let value = e.target.value;
        if (e.target.type === 'text') {
            value = value.replace(/^\s+/, '');
        }
        this.setState({ [e.target.name]: value })
    }

    onStatusChange = (e) => {
        this.setState({ status: parseInt(e.target.value) })
    }

    // Trigger Conditions
    handleConditionChange = (index, field, value) => {
        const conditions = [...this.state.triggerConditions];
        conditions[index] = { ...conditions[index], [field]: value };
        if (field === 'condition' && value === PT_CONDITION_TYPE.PAGE_LOADED) {
            conditions[index].targetId = '';
        }
        this.setState({ triggerConditions: conditions });
    }

    addCondition = () => {
        if (this.state.triggerConditions.length < 3) {
            this.setState({
                triggerConditions: [...this.state.triggerConditions, { condition: PT_CONDITION_TYPE.PAGE_LOADED, targetId: '' }]
            });
        }
    }

    removeCondition = (index) => {
        const conditions = this.state.triggerConditions.filter((_, i) => i !== index);
        this.setState({ triggerConditions: conditions });
    }

    // Distinct Displays
    handleDistinctDisplayChange = (e) => {
        const val = parseInt(e.target.value) || 0;
        this.setState({ distinctDisplayCount: val < 1 ? 1 : val })
    }

    handleUnlimitedChange = () => {
        this.setState(prev => ({
            distinctDisplayUnlimited: !prev.distinctDisplayUnlimited,
            distinctDisplayCount: !prev.distinctDisplayUnlimited ? 0 : 1
        }));
    }

    // Scheduling
    handleStartEnabledChange = () => {
        this.setState(prev => ({
            startEnabled: !prev.startEnabled,
            startDatetime: !prev.startEnabled ? prev.startDatetime : null
        }))
    }

    handleEndEnabledChange = () => {
        this.setState(prev => ({
            endEnabled: !prev.endEnabled,
            endDatetime: !prev.endEnabled ? prev.endDatetime : null
        }))
    }

    handleStartDateChange = (date) => {
        this.setState({ startDatetime: date })
    }

    handleEndDateChange = (date) => {
        this.setState({ endDatetime: date })
    }

    // Display Pages
    handleDisplayPagesChange = (selectedOptions) => {
        const selected = selectedOptions === null ? [] : selectedOptions;
        const hasOther = selected.some(o => o.value === 'other');
        this.setState({
            displayPages: selected,
            otherPages: hasOther ? (this.state.otherPages.length ? this.state.otherPages : ['']) : [''],
        });
    }

    handleOtherPageChange = (index, e) => {
        const otherPages = [...this.state.otherPages];
        otherPages[index] = e.target.value;
        this.setState({ otherPages });
    }

    addOtherPage = () => {
        this.setState({ otherPages: [...this.state.otherPages, ''] });
    }

    removeOtherPage = (index) => {
        const otherPages = this.state.otherPages.filter((_, i) => i !== index);
        this.setState({ otherPages: otherPages.length ? otherPages : [''] });
    }

    isOtherSelected = () => {
        return this.state.displayPages.some(o => o.value === 'other');
    }

    // Takeover Content
    handleContentChange = (e) => {
        this.setState({ takeoverContent: e.target.value })
    }

    togglePreview = () => {
        const draft = {
            isEditMode: this.state.isEditMode,
            pageTakeoverId: this.state.pageTakeoverId,
            originalData: this.state.originalData,
            name: this.state.name,
            status: this.state.status,
            triggerConditions: this.state.triggerConditions,
            distinctDisplayCount: this.state.distinctDisplayCount,
            distinctDisplayUnlimited: this.state.distinctDisplayUnlimited,
            startEnabled: this.state.startEnabled,
            startDatetime: this.state.startDatetime ? this.state.startDatetime.getTime() : null,
            endEnabled: this.state.endEnabled,
            endDatetime: this.state.endDatetime ? this.state.endDatetime.getTime() : null,
            displayPages: this.state.displayPages,
            otherPages: this.state.otherPages,
            takeoverContent: this.state.takeoverContent,
        };
        sessionStorage.setItem('pageTakeoverFormDraft', JSON.stringify(draft));
        this.props.history.push({
            pathname: '/page-takeover-preview',
            state: { htmlContent: this.state.takeoverContent }
        });
    }

    getMtTime = (date) => {
        //Get offset from mountain time using UTC
        //change 360 t0 420
        let ABBR = moment.tz("America/Denver").format("z");
        let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);
        // add that offset in date
        return moment(date).add(offDifference, 'minutes').toISOString()
    }

    // Validation & Submit
    handleSubmit = () => {
        console.log(this.validator,"this.validator", this.state);
        
        if (this.validator.allValid()) {

            // Build triggerActions from triggerConditions state
            const triggerActions = this.state.triggerConditions.map(cond => {
                const action = { condition: cond.condition };
                if (cond.condition === PT_CONDITION_TYPE.COMPONENT_CLICKED) {
                    action.targetId = cond.targetId;
                } else if (cond.condition === PT_CONDITION_TYPE.EVENT_FIRED) {
                    action.eventName = cond.targetId;
                }
                return action;
            });

            const payload = {
                name: this.state.name.trim(),
                status: this.state.status === 1 ? 'active' : 'inactive',
                triggerActions: triggerActions,
                distinctDisplays: {
                    ...(this.state.distinctDisplayUnlimited ? {} : { max: this.state.distinctDisplayCount }),
                    unlimited: this.state.distinctDisplayUnlimited,
                },
                startDatetime: this.state.startEnabled
                    ? { enabled: true, datetime: moment(this.state.startDatetime).tz("America/Denver").format() }
                    : { enabled: false },
                endDatetime: this.state.endEnabled
                    ? { enabled: true, datetime: moment(this.state.endDatetime).tz("America/Denver").format() }
                    : { enabled: false },
                displayPages: [
                    ...this.state.displayPages.filter(p => p.value !== 'other').map(p => p.value),
                    ...(this.isOtherSelected() ? this.state.otherPages.filter(v => v.trim()).map(v => v.trim()) : [])
                ],
                takeoverContent: this.state.takeoverContent,
            };

            this.setState({ loaderFlag: true })

            if (this.state.isEditMode) {
                payload.id = this.state.pageTakeoverId;
                this.apiserve.sendevent("pageTakeOver|update", payload);
            } else {
                this.apiserve.sendevent("pageTakeOver|create", payload);
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    handleCancel = () => {
        this.setState({ discardPopup: true })
    }

    discardYes = () => {
        this.props.history.push('/page-takeover-list');
    }

    discardNo = () => {
        this.setState({ discardPopup: false })
    }

    errorMsgPopup = () => {
        this.setState({ errorPopup: false })
    }
    render() {
        this.validator.purgeFields()
        const { isEditMode, triggerConditions } = this.state;

        return (
            <div className="right_side_wrapper">
                <ul className="fpg_admin_tab disp_flex">
                    <li className="active">
                        <p className="uppercase text_left">
                            <div>{isEditMode ? 'EDIT PAGE TAKEOVER' : 'CREATE PAGE TAKEOVER'}</div>
                        </p>
                    </li>
                </ul>
                <div className="back_date d_flex d_flex_align_center">
                    <Link className="back_link" to="/page-takeover-list">
                        <svg width="5" height="10" viewBox="0 0 5 10" fill="none"><path d="M5 0L0 5L5 10V0Z" fill="black" /></svg>
                        Back to List
                    </Link>
                </div>

                <div className="page_takeover_create pl_15 pr_20">
                    <div className='page_takeover_col'>
                        {/* Section 1: Name + Status */}
                        <div className="form_section top_sec">
                            <h3 className="section_title">Basic Information</h3>
                            <div className="form_row_flex">
                                <div className="form_col">
                                    <TextField
                                        label="Name"
                                        type="text"
                                        name="name"
                                        value={this.state.name}
                                        placeholder="Enter page takeover name"
                                        onChange={this.onChangeHandler}
                                        require={true}
                                        fpgerror={this.validator.message('name', this.state.name, 'required|pageTakeoverName')}
                                    />
                                </div>
                            </div>
                            <div className="form_row_flex" style={{ marginTop: '20px' }}>
                                <div className="form_col">
                                    <DropdownMaster
                                        label="Status"
                                        name="status"
                                        options={[{_id: 1, name: 'Active'}, {_id: 2, name: 'Inactive'}]}
                                        value={this.state.status}
                                        onChange={this.onStatusChange}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Section 2: Trigger Conditions */}
                        <div className="form_section">
                            <h3 className="section_title">Trigger Conditions</h3>
                            <div className="condition_block_group">
                                {triggerConditions.map((cond, index) => (
                                    <ConditionBlock
                                        key={index}
                                        index={index}
                                        condition={cond.condition}
                                        targetId={cond.targetId}
                                        onChange={this.handleConditionChange}
                                        onRemove={this.removeCondition}
                                        canRemove={triggerConditions.length > 1}
                                        error={cond.condition !== PT_CONDITION_TYPE.PAGE_LOADED ? this.validator.message('conditionValue_' + index, cond.targetId, 'conditionValueRequired') : null}
                                    />
                                ))}
                                <span
                                    className={`add_condition_btn ${triggerConditions.length >= 3 ? 'disabled' : ''}`}
                                    onClick={this.addCondition}
                                >
                                    <FpgPlusIcon className="pointer" width="20" height="20" color="#000000" stroke="#fff" />
                                </span>
                                <p className="condition_info_text">All conditions must be met for the takeover to trigger</p>
                            </div>
                        </div>

                        {/* Section 3: Distinct Displays */}
                        <div className="form_section">
                            <h3 className="section_title">Distinct Displays</h3>
                            <div className="d_flex form_row_flex d_flex_align_center">
                                <div className="field_row_inner">
                                    <label className="required">Display Count</label>
                                    <div className="field_input">
                                        <input
                                            type="number"
                                            name="distinctDisplayCount"
                                            value={this.state.distinctDisplayUnlimited ? '' : this.state.distinctDisplayCount}
                                            onChange={this.handleDistinctDisplayChange}
                                            disabled={this.state.distinctDisplayUnlimited}
                                            min="1"
                                            placeholder={this.state.distinctDisplayUnlimited ? 'Unlimited' : 'Enter count'}
                                            autoComplete="off"
                                        />
                                    </div>
                                    {!this.state.distinctDisplayUnlimited && <span className="error">{this.validator.message('displayCount', this.state.distinctDisplayCount, 'required|displayCountRequired')}</span>}
                                </div>
                                <CheckBox
                                    label="Unlimited"
                                    type="checkbox"
                                    id="distinctDisplayUnlimited"
                                    name="distinctDisplayUnlimited"
                                    checked={this.state.distinctDisplayUnlimited}
                                    onChange={this.handleUnlimitedChange}
                                />
                            </div>
                        </div>

                        {/* Section 4: Scheduling */}
                        <div className="form_section">
                            <h3 className="section_title">Scheduling</h3>
                            <div className="scheduling_row d_flex form_row_flex d_flex_align_center">
                                <div className="form_col form_col_4">
                                    <CheckBox
                                        label="Enable Start Date"
                                        type="checkbox"
                                        id="startEnabled"
                                        name="startEnabled"
                                        checked={this.state.startEnabled}
                                        onChange={this.handleStartEnabledChange}
                                    />
                                </div>
                                {this.state.startEnabled && <div className="form_col form_col_6">
                                    <div className="field_row_inner">
                                        <div className="field_input">
                                            <DatePicker
                                                selected={this.state.startDatetime}
                                                onChange={this.handleStartDateChange}
                                                showTimeSelect
                                                dateFormat="MMMM d, yyyy h:mm aa"
                                                timeIntervals={5}
                                                disabled={!this.state.startEnabled}
                                                placeholderText="Select start date & time"
                                                className="datepicker_input"
                                            />
                                            <span className="error">{this.validator.message('startDatetime', this.state.startDatetime, 'startDateRequired')}</span>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                            <div className="scheduling_row d_flex form_row_flex d_flex_align_center">
                                <div className="form_col form_col_4">
                                    <CheckBox
                                        label="Enable End Date"
                                        type="checkbox"
                                        id="endEnabled"
                                        name="endEnabled"
                                        checked={this.state.endEnabled}
                                        onChange={this.handleEndEnabledChange}
                                    />
                                </div>
                                {this.state.endEnabled && <div className="form_col form_col_6">
                                    <div className="field_row_inner">
                                        <div className="field_input">
                                            <DatePicker
                                                selected={this.state.endDatetime}
                                                onChange={this.handleEndDateChange}
                                                showTimeSelect
                                                dateFormat="MMMM d, yyyy h:mm aa"
                                                timeIntervals={5}
                                                disabled={!this.state.endEnabled}
                                                placeholderText="Select end date & time"
                                                className="datepicker_input"
                                                minDate={this.state.startDatetime}
                                            />
                                            <span className="error">{this.validator.message('endDatetime', this.state.endDatetime, 'endDateRequired')}</span>
                                            {this.state.startEnabled && this.state.startDatetime && this.state.endDatetime &&
                                                <span className="error">{this.validator.message('endAfterStart', this.state.endDatetime, `endAfterStart:${this.state.startDatetime ? this.state.startDatetime.getTime() : ''}`)}</span>
                                            }
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                    <div className='page_takeover_col'>
                        {/* Section 5: Display Pages */}
                        <div className="form_section">
                            <h3 className="section_title">Display Pages</h3>
                            <div className="form_col">
                                <div className="field_row_inner">
                                    <label className="required">Display Pages</label>
                                    <div className='field_input'>
                                        <Select
                                            isMulti
                                            value={this.state.displayPages}
                                            onChange={this.handleDisplayPagesChange}
                                            options={DISPLAY_PAGE_OPTIONS}
                                            placeholder="Select pages..."
                                            className="react_select_container"
                                            classNamePrefix="react_select"
                                        />
                                        <span className="error">{this.validator.message('displayPages', this.state.displayPages, 'displayPagesRequired')}</span>
                                    </div>
                                </div>
                                {this.isOtherSelected() &&
                                    <div className="other_pages_group" style={{ marginTop: '10px' }}>
                                        {this.state.otherPages.map((val, idx) => (
                                            <div key={idx} className="field_row_inner d_flex d_flex_align_center" style={{ marginBottom: '8px', gap: '10px' }}>
                                                <label className="required">Other Page Path #{idx + 1}</label>
                                                <div className="field_input">
                                                    <input
                                                        type="text"
                                                        value={val}
                                                        onChange={(e) => this.handleOtherPageChange(idx, e)}
                                                        placeholder="Enter custom page path (e.g. /custom-page)"
                                                        autoComplete="off"
                                                    />
                                                    <span className="error">{this.validator.message('Other Page Path #' + (idx + 1), val, 'required|otherPageRequired')}</span>
                                                </div>
                                                {this.state.otherPages.length > 1 &&
                                                    <span className="condition_block_remove" style={{ cursor: 'pointer' }} onClick={() => this.removeOtherPage(idx)}>
                                                        <FpgMinusIcon className="pointer" width="20" height="20" color="#000000" stroke="#fff" />
                                                    </span>
                                                }
                                            </div>
                                        ))}
                                        <span className="add_condition_btn" onClick={() => this.addOtherPage()}>
                                            <FpgPlusIcon className="pointer" width="20" height="20" color="#000000" stroke="#fff" />
                                        </span>
                                    </div>
                                }
                            </div>
                        </div>

                        {/* Section 6: Takeover Content */}
                        <div className="form_section">
                            <h3 className="section_title">Takeover Content</h3>
                            <div className="field_row_inner">
                                <label className="required">HTML Content</label>
                                <div className="field_input" style={{width: '70%'}}>
                                    <textarea
                                        name="takeoverContent"
                                        value={this.state.takeoverContent}
                                        onChange={this.handleContentChange}
                                        placeholder="Enter fully qualified HTML including styles, images, and embed tags"
                                        className="html_textarea"
                                        rows="12"
                                    />
                                    <span className="error">{this.validator.message('takeoverContent', this.state.takeoverContent, 'required|takeoverContentRequired')}</span>
                                </div>
                            </div>
                            <button
                                type="button"
                                className="preview_btn"
                                onClick={this.togglePreview}
                                disabled={!this.state.takeoverContent}
                            >
                                Preview
                            </button>
                        </div>
                    </div>                      

                    {/* Action Buttons */}
                    <div className="text_center field_row w_100 buttons_outer">
                        <button type="button" className="grayBTN uppercase" onClick={this.handleCancel} > Cancel </button>
                        <button type="button" className="orangeBTN active uppercase" onClick={this.handleSubmit} disabled={isEditMode && !this.isFormDirty()}> Save </button>
                    </div>
                </div>

                {/* Discard Popup */}
                {this.state.discardPopup ?
                    <PopUpCustomAll
                        HeaderName='Discard Changes?'
                        insideDetails='You have unsaved changes that will be lost'
                        insideData='Do you want to proceed?'
                        popupState={this.discardNo}
                        yesPopUp={this.discardYes}
                    />
                    : ''}

                {/* Error Popup */}
                {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }

                {/* Loader */}
                {this.state.loaderFlag ? <Loader /> : ''}
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PageTakeoverCreate)
